<template>
  <div class="filter">
    <div class="filter_item filter_item-category">
      <label class="filter_item-label">类型：</label>
      <el-select
        v-model="articleTypeId"
        @change="handleChangeType"
        v-show="isShowMoreConditon"
      >
        <el-option
          v-for="(item, index) in docType"
          :key="index"
          :value="item.name"
          :label="item.label"
        />
      </el-select>
      <el-radio-group
        v-model="articleTypeId"
        @change="handleChangeType"
        v-show="!isShowMoreConditon"
      >
        <el-radio-button
          v-for="(item, index) in docType"
          :key="index"
          :label="item.name"
        >
          {{ item.label }}
        </el-radio-button>
      </el-radio-group>
      <treeSelect
        v-show="isShowMoreConditon"
        ref="treeSelectCategory"
        label-name="数据分类："
        placeholder="数据分类"
        :tree-list="navData"
        :format-option="formatCategory"
        @changeSelected="changeSelected($event, 'category')"
      />
      <i
        :class="'icon condition-expand-icon icon-arrow-' + showClass"
        @click="updateExpand"
      />
    </div>
    <div
      class="filter_item"
      v-show="isShowMoreConditon"
    >
      <label class="filter_item-label">上传时间：</label>
      <el-radio-group
        v-model="timeFlag"
        @change="handleChangeTime"
      >
        <el-radio-button
          v-for="(item, index) in timeArr"
          :key="index"
          :label="item.code"
        >
          {{ item.name }}
        </el-radio-button>
      </el-radio-group>
      <Datepicker
        separator="~"
        :default-time="defaultTime"
        :is-show-short-cuts="false"
        :is-show-icon="false"
        @timeChange="timeChange"
      />
    </div>
    <div
      class="filter_item filter_item-departKeyword"
      v-show="isShowMoreConditon"
    >
      <treeSelect
        ref="treeSelectDepart"
        placeholder="录入单位名称"
        :tree-option="{
          multiple: true,
          flat: isDepartmentFlat,
          clearable: false
        }"
        :tree-list="departmentList"
        :format-option="formatDepartment"
        @changeSelected="changeSelected($event, 'department')"
      />
      <div class="keyword">
        <label class="filter_item-label">信息来源：</label>
        <el-input
          v-model="zzsrc"
          placeholder="请输入信息来源检索"
        />
      </div>
      <label class="filter_item-label">是否敏感：</label>
      <el-checkbox
        v-model="isSensitive"
        :true-label="1"
        :false-label="0"
      />
    </div>
    <div
      class="filter_item filter_item-theme"
      v-show="isShowMoreConditon"
    >
      <div class="keyword">
        <label class="filter_item-label">标题：</label>
        <el-input
          v-model="title"
          placeholder="请输入标题检索"
        />
      </div>
      <label class="filter_item-label">主题：</label>
      <el-select
        v-model="topTopicId"
        class="topTop-theme"
        @change="
          () => {
            this.secTopicId = '';
          }
        "
        placeholder=""
      >
        <el-option
          v-for="(item, index) in themeData"
          :key="index"
          :value="item.id"
          :label="item.name"
        />
      </el-select>
      <el-select
        v-model="secTopicId"
        v-show="themeChild.length !== 0"
      >
        <el-option
          v-for="(item, index) in themeChild"
          :key="index"
          :value="item.id"
          :label="item.name"
        />
      </el-select>
    </div>
    <div
      class="filter_item filter_item-region"
      v-show="isShowMoreConditon"
    >
      <label class="filter_item-label">地域：</label>
      <regionPicker
        ref="regionPicker"
        :init-province="initProvince"
        :init-city="initCity"
        :init-country="initCountry"
        :is-expand="true"
        :region-list="regionList"
      />
      <label class="filter_item-label">领域：</label>
      <el-select v-model="topCategoryId">
        <el-option
          v-for="(item, index) in categories"
          :key="index"
          :value="item.id"
          :label="item.name"
        />
      </el-select>
    </div>
    <div
      class="filter_item filter_item-keyword"
      v-show="isShowMoreConditon"
    >
      <div class="keyword">
        <label class="filter_item-label">关键词：</label>
        <el-input
          v-model="keyWords"
          placeholder="请输入关键词检索"
        />
      </div>
      <el-button
        class="btn-search"
        @click="handleSearch"
      >
        查询
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  getFirstDayOfMonth,
  getEndDayOfMonth,
  getTimeParamCy,
  timeFormat
} from '@common/util.js'
import regionPicker from '@components/common/RegionPicker'
import Datepicker from '@components/common/DatePicker'
import treeSelect from '@views/jlxk/review/components/treeSelect'
export default {
  name: 'Conditon',
  props: {
    navData: {
      type: Array,
      default: () => []
    },
    departmentList: {
      type: Array,
      default: () => []
    },
    themeData: {
      type: Array,
      default: () => []
    },
    regionList: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Datepicker,
    treeSelect,
    regionPicker
  },
  data() {
    return {
      articleTypeId: '0',
      docType: [
        {
          name: '0',
          label: '全部'
        },
        {
          name: '1',
          label: '图文'
        },
        {
          name: '2',
          label: '图集'
        },
        {
          name: '6',
          label: '音频'
        },
        {
          name: '5',
          label: '视频'
        },
        {
          name: '3',
          label: '书籍文件'
        },
        {
          name: '4',
          label: '影视作品'
        }
      ],
      showClass: 'up',
      defaultTime: [
        getTimeParamCy('7d').startTime,
        timeFormat(new Date().setHours(23, 59, 59, 999))
      ],
      beginCreated: '',
      endCreated: '',
      timeFlag: '7d',
      timeArr: [
        {
          code: '24h',
          name: '24小时'
        },
        {
          code: '7d',
          name: '7天'
        },
        {
          code: 'month',
          name: '本月'
        }
      ],
      checkedCategory: [],
      checkedDepartment: [],
      initProvince: String(login_cookie['provinceId']),
      initCity: String(login_cookie['cityId']),
      initCountry: String(login_cookie['countyId']),
      keyWords: '',
      zzsrc: '',
      isSensitive: 0,
      title: '',
      // 主题
      topTopicId: '',
      secTopicId: '',
      topCategoryId: ''
    }
  },
  computed: {
    isDepartmentFlat() {
      try {
        return !xk_department_tree_cascade
      } catch (error) {
        return true
      }
    },
    isShowMoreConditon() {
      return this.showClass === 'up'
    },
    departmentIds() {
      if (this.checkedDepartment.length === 0) return ''
      if (this.isDepartmentFlat) {
        return this.checkedDepartment.map(item => item.id).join(',')
      }
      let result = []
      this.checkedDepartment.forEach(item => {
        result.push(item.id)
        if (item.child && item.child.length !== 0) {
          item.child.forEach(subItem => {
            result.push(subItem.id)
            if (subItem.child && subItem.child.length !== 0) {
              subItem.child.forEach(thirdItem => {
                result.push(thirdItem.id)
                if (thirdItem.child && thirdItem.child.length !== 0) {
                  thirdItem.child.forEach(fourItem => {
                    result.push(fourItem.id)
                    if (fourItem.child && fourItem.child.length !== 0) {
                      fourItem.child.forEach(fiveItem => {
                        result.push(fiveItem.id)
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
      return result.join(',')
    },
    dataCategoryIds() {
      if (this.checkedCategory.length === 0) return ''
      return this.checkedCategory.map(item => item.id).join(',')
    },
    themeChild() {
      let result = this.themeData.find(item => item.id === this.topTopicId)
      return this.topTopicId !== '' && result
        ? [{ name: '全部', id: '' }].concat(result.children)
        : []
    },
    conditonParams() {
      return {
        articleTypeIds:
          this.articleTypeId === '0' ? undefined : this.articleTypeId,
        dataCategoryIds: this.dataCategoryIds,
        beginCreated: this.beginCreated,
        endCreated: this.endCreated,
        departmentIds: this.departmentIds,
        zzsrc: this.zzsrc,
        isSensitive: this.isSensitive,
        title: this.title,
        topTopicId: this.topTopicId,
        secTopicId: this.secTopicId,
        provinceId: this.$refs.regionPicker && this.$refs.regionPicker.curProvince,
        cityId: this.$refs.regionPicker && this.$refs.regionPicker.curCity,
        countyId: this.$refs.regionPicker && this.$refs.regionPicker.curCounty,
        topCategoryId: this.topCategoryId,
        keywords: this.keyWords
      }
    }
  },
  created() {
    this.beginCreated = this.defaultTime[0]
    this.endCreated = this.defaultTime[1]
  },
  mounted() {},
  methods: {
    changeSelected(value, flag) {
      flag === 'category'
        ? (this.checkedCategory = [...value])
        : (this.checkedDepartment = [...value])
    },
    initParams() {
      this.status = '2,4,6'
      this.showClass = 'up'
      this.articleTypeId = '0'
      this.timeFlag = '7d'
      if (this.$refs.treeSelectDepart) {
        this.$refs.treeSelectDepart.checkedTreeList = []
      }
      this.checkedDepartment = []
      if (this.$refs.treeSelectCategory) {
        this.$refs.treeSelectCategory.checkedTreeList = []
      }
      this.checkedCategory = []
      this.keyWords = ''
      this.defaultTime = [
        getTimeParamCy(this.timeFlag).startTime,
        this.isOvertime
          ? timeFormat(new Date().setHours(23, 59, 59, 999))
          : getTimeParamCy(this.timeFlag).endTime
      ]
      this.beginCreated = this.defaultTime[0]
      this.endCreated = this.defaultTime[1]
    },
    recordParmas(value) {
      this.status = value.status || '2,4,6'
      this.articleTypeId = value.articleTypeIds || '0'
      this.timeFlag = value.timeFlag
      if (this.$refs.treeSelectDepart) {
        let department =
          value.departmentIds === '' ? [] : JSON.parse(value.departmentIds)
        this.$refs.treeSelectDepart.checkedTreeList = department
        this.checkedDepartment = department
      }
      if (this.$refs.treeSelectCategory) {
        let category =
          value.dataCategoryIds === '' ? [] : JSON.parse(value.dataCategoryIds)
        this.$refs.treeSelectCategory.checkedTreeList = category
        this.checkedCategory = category
      }
      this.defaultTime = [value.beginCreated, value.endCreated]
      this.beginCreated = this.defaultTime[0]
      this.endCreated = this.defaultTime[1]
    },
    handleChangeType() {
      if (this.isShowMoreConditon) return false
      this.handleSearch()
    },
    // 切换发布时间快捷键
    handleChangeTime() {
      switch (this.timeFlag) {
        case 'month':
          this.beginCreated = getFirstDayOfMonth()
          this.endCreated = getEndDayOfMonth()
          break
        default:
          this.beginCreated = getTimeParamCy(this.timeFlag).startTime
          this.endCreated = this.isOvertime
            ? timeFormat(new Date().setHours(23, 59, 59, 999))
            : getTimeParamCy(this.timeFlag).endTime
          break
      }
      this.defaultTime = [this.beginCreated, this.endCreated]
    },
    timeChange(val) {
      this.timeFlag = ''
      this.beginCreated = val[0]
      this.endCreated = val[1]
    },
    // 列表查询
    handleSearch() {
      this.$emit('handleSearch', this.conditonParams)
    },
    updateExpand() {
      this.showClass = this.showClass === 'down' ? 'up' : 'down'
      this.$emit('updateExpand', this.showClass === 'up')
    },
    // 格式tree数据
    formatDepartment(node) {
      if (node.child && !node.child.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.name,
        children: node.child
      }
    },
    formatCategory(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter {
  flex-shrink: 0;
  padding: 10px 8px 2px 8px;
  &_bottom {
    border-bottom: 1px solid #e7e9ef;
  }
  &_item {
    display: flex;
    height: 30px;
    align-items: center;
    margin-bottom: 8px;
    &-label {
      width: 71px;
      text-align: right;
      font-size: 14px;
      flex-shrink: 0;
      color: #333;
    }
    i.condition-expand-icon {
      margin-left: 10px;
      cursor: pointer;
    }
    /deep/ .el-radio-group {
      display: flex;
      .el-radio-button {
        margin-right: 8px;
        outline: none;
        &:last-child {
          margin-right: 4px;
        }
        &.is-active {
          .el-radio-button__inner {
            color: #0499f3;
            border-color: #4497ec;
          }
        }
        &__inner {
          height: 30px;
          line-height: 28px;
          padding: 0 14px;
          background-color: #fff;
          border: 1px solid #e7e7e7;
          border-radius: 5px;
          box-shadow: none;
          font-size: 13px;
        }
      }
    }
    /deep/ .el-input__inner {
      width: 195px;
      background: #ffffff;
      border: 1px solid #e7e7e7;
      border-radius: 5px;
      font-family: founder_youhei_508R;
      font-size: 13px;
    }
    .btn-search {
      width: 60px;
      height: 30px;
      background: #4497ec;
      border-radius: 5px;
      padding: 0 17px;
      color: #fff;
    }
    &-category {
      /deep/ .tree-box {
        margin-left: 20px;
      }
    }
    &-departKeyword {
      .keyword {
        margin-right: 20px;
      }
      /deep/ .tree-box {
        margin-right: 20px;
      }
      /deep/ .el-checkbox {
        margin-top: 2px;
      }
    }
    .keyword {
      display: flex;
      align-items: center;
    }
    &-theme {
      /deep/ .el-select {
        width: 186px;
        &.topTop-theme {
          margin-right: 9px;
        }
        .el-input__inner {
          width: 100%;
          font-family: founder_youhei_508R;
        }
      }
    }
    &-region {
      /deep/ .cy-region-picker {
        max-width: 380px;
        .el-select {
          flex-basis: calc(100% / 3);
          .el-input__inner {
            width: 100%;
          }
        }
         &_province {
          .el-select {
            flex-basis: 100%;
          }
        }
      }
    }
    &-keyword {
      justify-content: space-between;
    }
  }
}
</style>
